import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "card rounded-top" }
const _hoisted_4 = { class: "card-body pt-9 pb-0" }
const _hoisted_5 = { class: "d-flex align-items-center flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_6 = { class: "me-7 mb-4" }
const _hoisted_7 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = { class: "text-gray-800 fs-2 fw-bolder me-1 name-header" }
const _hoisted_13 = { href: "#" }
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_15 = { class: "d-flex flex-wrap fw-bold fs-6 pe-2" }
const _hoisted_16 = { class: "d-flex align-items-center text-gray-400 me-15 mb-2" }
const _hoisted_17 = { class: "info-text" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user icon" }, null, -1)
const _hoisted_19 = {
  key: 0,
  href: "#",
  class: "d-flex align-items-center text-gray-400 me-5 mb-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_22 = ["value"]
const _hoisted_23 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 mb-2"
}
const _hoisted_24 = { class: "info-text" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope icon" }, null, -1)
const _hoisted_26 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_27 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Personal Details ")
const _hoisted_30 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Business Details ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_UploadProfile = _resolveComponent("UploadProfile")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, {
      to: "/settings",
      text: "Back to settings"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Avatar, {
                  withUploadButton: true,
                  size: 64,
                  imageFile: _ctx.avatar,
                  acronym: _ctx.acronym,
                  useIcon: false,
                  fontSize: `2em`
                }, null, 8, ["imageFile", "acronym"]),
                _createVNode(_component_UploadProfile, {
                  profilePicture: _ctx.avatar,
                  onRemoveProfileAvatar: _ctx.handleRemoveAvatar,
                  onChangeProfileForm: _ctx.handleUpload,
                  ref: "uploadAvatarModal"
                }, null, 8, ["profilePicture", "onRemoveProfileAvatar", "onChangeProfileForm"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.authUser.first_name
                          ? _ctx.$filters.capitalize(_ctx.authUser.first_name)
                          : '') + " " + _toDisplayString(_ctx.authUser.last_name
                          ? _ctx.$filters.capitalize(_ctx.authUser.last_name)
                          : ''), 1),
                    _createElementVNode("a", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen026.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode("   " + _toDisplayString(_ctx.userRole), 1)
                      ])
                    ]),
                    (_ctx.authUser?.mobile_number)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_19, [
                          _hoisted_20,
                          _hoisted_21,
                          _withDirectives(_createElementVNode("input", {
                            class: "form-control text-truncate bg-none border-0 p-0 m-0 text-muted cursor-pointer info-text",
                            readonly: "",
                            style: {"width":"110px"},
                            value: (_ctx.authUser || {}).mobile_number
                          }, null, 8, _hoisted_22), [
                            [_directive_mask, _ctx.mobileMasking]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _hoisted_25,
                        _createTextVNode("   " + _toDisplayString((_ctx.authUser || {}).email), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: "/profile/overview",
                  class: "nav-link me-6",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                })
              ]),
              (_ctx.canAccess())
                ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                    _createVNode(_component_router_link, {
                      class: "nav-link me-6",
                      to: "/profile/business-details",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}